/*
  *** Usage ***
  data-vero-form - Required. To be placed on form element.
  data-vero-id - Required. To be placed on email field.
  data-vero-event-name - Optional. Vero event name to trigger. To be placed on form element.
  data-vero-event-properties - Optional. JSON object of properties to be passed to triggered event. To be placed on form element.
  data-vero-property - Optional. Vero customer properties to be passed to Vero. To be placed on relevant input/s. Currently does not work with radio buttons.
*/

document.addEventListener('DOMContentLoaded', () => {
  const veroForms = document.querySelectorAll('[data-vero-form]');

  if (!veroForms) {
    return;
  }

  veroForms.forEach((form) => {
    const veroUserID = form.querySelector('[data-vero-id]');

    if (!veroUserID) {
      throw new Error(
        'data-vero-id attribute is missing and must be applied to a input collecting the users email address'
      );
    }

    form.addEventListener('submit', (e) => {
      // Prevent form from submitting
      e.preventDefault();

      // Set up user object
      const userObject = {
        id: veroUserID.value,
        email: veroUserID.value,
      };

      // Add any supplied customer properties to the user object
      const veroProperties = form.querySelectorAll('[data-vero-property]');
      if (veroProperties) {
        veroProperties.forEach((input) => {
          if (input.value) {
            if (input.type === 'checkbox') {
              if (input.checked) {
                userObject[input.dataset.veroProperty] = input.value;
              }
            } else {
              userObject[input.dataset.veroProperty] = input.value;
            }
          }
        });
      }

      // Identify and update user
      _veroq.push(['user', userObject]);

      // Trigger any supplied event and pass any event properties
      if (form.hasAttribute('data-vero-event-name')) {
        let eventProperties = {};
        if (form.hasAttribute('data-vero-event-properties')) {
          eventProperties = JSON.parse(form.dataset.veroEventProperties);
        }
        _veroq.push(['track', form.dataset.veroEventName, eventProperties]);
      }

      // Submit form
      form.submit();
    });
  });
});
